/* RESPONSIBLE TEAM: team-tickets-1 */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import Admin from 'embercom/models/admin';
import type ThemeService from 'embercom/services/theme-service';

export default class InboxRoute extends Route {
  @service declare router: RouterService;
  @service declare themeService: ThemeService;

  analytics = {
    place: 'inbox',
  };

  async beforeModel(transition: Transition) {
    if (transition.to.name === 'inbox.workspace.conversation-frame') {
      try {
        await Admin.meWithoutRedirect();
      } catch (e) {
        this.router.transitionTo('frame-login', { redirect_url: window.location.href });
      }
    }
  }
}
